import useIsFeatureEnabled from 'src/commons/hooks/useIsFeatureEnabled';
import { WeblabedFeatures } from 'src/commons/constants';
import { logger } from 'src/commons/utils/logger';
import { useInternalChromeConfigContext } from 'src/providers/InternalChromeConfigContextProvider';
import { shouldUpdateLinks } from './shouldUpdateLinks';
import { appendActiveParams } from './urlUpdateUtils';

/**
 * Returns a function that appends active legacy metrics params to a redirect URL if
 * updating is active (app is allowlisted and at least one param is in session
 * storage), or undefined otherwise.
 *
 * Used by the region switcher to carry legacy metrics params to the new domain.
 *
 * Requires the url update weblab to be enabled.
 */
export const useRegionSwitcherUrlUpdater = ():
  | ((url: URL) => void)
  | undefined => {
  const isUrlUpdateFeatureEnabled = useIsFeatureEnabled(
    WeblabedFeatures.LEGACY_CONVERSION_METRICS_URL_REWRITE_ANDON_CORD,
  );
  const { config: internalChromeConfig } = useInternalChromeConfigContext();
  const appName = internalChromeConfig.applicationName;

  if (!isUrlUpdateFeatureEnabled) {
    logger.info(
      'useRegionSwitcherUrlUpdater: disabled, url update weblab not enabled',
    );
    return undefined;
  }
  if (!shouldUpdateLinks(appName)) return undefined;
  return appendActiveParams;
};
